<div class="card-container" *ngIf="routerUrl.includes('questions')">
  <div class="row">
    <div class="col-5">
      <div class="chart-container" *ngIf="chartBarHorizontal?.series?.length">
        <apx-chart [series]="chartBarHorizontal!.series!" [chart]="chartBarHorizontal!.chart!"
          [plotOptions]="chartBarHorizontal!.plotOptions!" [colors]="chartBarHorizontal!.colors!"
          [xaxis]="chartBarHorizontal!.xaxis!" [yaxis]="chartBarHorizontal!.yaxis!"
          [dataLabels]="chartBarHorizontal!.dataLabels!" [tooltip]="chartBarHorizontal!.tooltip!"
          [title]="chartBarHorizontal!.title!" [legend]="chartBarHorizontal!.legend!">
        </apx-chart>
      </div>
    </div>

    <div class="col-2 d-flex justify-content-center align-items-center">
      <div class="row g-2">
        <mat-card *ngFor="let ticket of questionsStatus" class="col-6 status-card">
          <div class="row">
            <div class="col-8 d-flex justify-content-left align-items-center">
              <div class="status-text text-left p-3">
                {{ ticket.status }}
              </div>
            </div>
            <div class="col-4 text-right">
              <div class="circle" [ngStyle]="{ 
                      'background-color': ticket.color.background,
                      'border-color': ticket.color.border
                    }">
                {{ ticket.count }}
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>

    <div class="col-5">
      <div class="chart-container" *ngIf="consultantFarmersChartOptions?.series?.length">
        <apx-chart [series]="consultantFarmersChartOptions.series!" [chart]="consultantFarmersChartOptions.chart!"
          [plotOptions]="consultantFarmersChartOptions.plotOptions!" [colors]="consultantFarmersChartOptions.colors!"
          [xaxis]="consultantFarmersChartOptions.xaxis!" [yaxis]="consultantFarmersChartOptions.yaxis!"
          [dataLabels]="consultantFarmersChartOptions.dataLabels!" [tooltip]="consultantFarmersChartOptions.tooltip!"
          [title]="consultantFarmersChartOptions.title!" [legend]="consultantFarmersChartOptions.legend!">
        </apx-chart>
      </div>
    </div>
  </div>
</div>

<div *ngIf="routerUrl.includes('consultant')">
  <div class="chart-container">
    <div class="row">
      <div class="col-6" *ngIf="consultantFarmersChartOptions2?.series?.length">
        <apx-chart [series]="consultantFarmersChartOptions2.series!" [chart]="consultantFarmersChartOptions2.chart!"
          [plotOptions]="consultantFarmersChartOptions2.plotOptions!" [colors]="consultantFarmersChartOptions2.colors!"
          [xaxis]="consultantFarmersChartOptions2.xaxis!" [yaxis]="consultantFarmersChartOptions2.yaxis!"
          [dataLabels]="consultantFarmersChartOptions2.dataLabels!" [tooltip]="consultantFarmersChartOptions2.tooltip!"
          [title]="consultantFarmersChartOptions2.title!" [legend]="consultantFarmersChartOptions2.legend!">
        </apx-chart>
      </div>

      <div class="col-3" *ngIf="advicePieChartOptions?.series?.length">
        <apx-chart [series]="advicePieChartOptions.series!" [chart]="advicePieChartOptions.chart!"
          [labels]="advicePieChartOptions.labels!" [legend]="advicePieChartOptions.legend!"
          [title]="advicePieChartOptions.title!" [colors]="advicePieChartOptions.colors!"
          [dataLabels]="advicePieChartOptions.dataLabels!">
        </apx-chart>
      </div>

      <div class="col-3" *ngIf="categoryPieChartOptions?.series?.length">
        <apx-chart [series]="categoryPieChartOptions.series!" [chart]="categoryPieChartOptions.chart!"
          [labels]="categoryPieChartOptions.labels!" [legend]="categoryPieChartOptions.legend!"
          [title]="categoryPieChartOptions.title!" [colors]="categoryPieChartOptions.colors!"
          [dataLabels]="categoryPieChartOptions.dataLabels!">
        </apx-chart>
      </div>
    </div>
  </div>
</div>

<div class="row my-2" *ngIf="routerUrl.includes('carbon-footprint')">
  <div class="col-6 offset-3" *ngIf="carbonPieChartOptions?.series?.length">
    <apx-chart [series]="carbonPieChartOptions!.series!" [chart]="carbonPieChartOptions!.chart!"
      [labels]="carbonPieChartOptions!.labels!" [legend]="carbonPieChartOptions!.legend!"
      [title]="carbonPieChartOptions!.title!" [colors]="carbonPieChartOptions!.colors!"
      [dataLabels]="carbonPieChartOptions!.dataLabels!">
    </apx-chart>
  </div>
  <div class="col-6" *ngIf="carbonBarChartOptions?.series?.length">
    <apx-chart [series]="carbonBarChartOptions.series!" [chart]="carbonBarChartOptions.chart!"
      [plotOptions]="carbonBarChartOptions.plotOptions!" [colors]="carbonBarChartOptions.colors!"
      [xaxis]="carbonBarChartOptions.xaxis!" [yaxis]="carbonBarChartOptions.yaxis!"
      [dataLabels]="carbonBarChartOptions.dataLabels!" [tooltip]="carbonBarChartOptions.tooltip!"
      [title]="carbonBarChartOptions.title!" [legend]="carbonBarChartOptions.legend!">
    </apx-chart>
  </div>
  <div class="col-6" *ngIf="carbonBarVerticalChartOptions?.series?.length">
    <apx-chart [series]="carbonBarVerticalChartOptions.series!" [chart]="carbonBarVerticalChartOptions.chart!"
      [plotOptions]="carbonBarVerticalChartOptions.plotOptions!" [colors]="carbonBarVerticalChartOptions.colors!"
      [xaxis]="carbonBarVerticalChartOptions.xaxis!" [yaxis]="carbonBarVerticalChartOptions.yaxis!"
      [dataLabels]="carbonBarVerticalChartOptions.dataLabels!" [tooltip]="carbonBarVerticalChartOptions.tooltip!"
      [title]="carbonBarVerticalChartOptions.title!" [legend]="carbonBarVerticalChartOptions.legend!">
    </apx-chart>
  </div>
  
</div>